import React, { useState } from "react";
import MediaDetailModal, { resolveMediaImg } from "./MediaDetailModal";

const parseMedia = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") { try { return JSON.parse(raw || "[]"); } catch { return []; } }
  return [];
};

// Compact card grid shown inside experience entries.
// cardStyle: "dark" (default) | "light" | "terminal"
const ExperienceMediaCards = ({ media: rawMedia, cardStyle = "dark" }) => {
  const [selected, setSelected] = useState(null);
  const media = parseMedia(rawMedia).filter((m) => m.title || m.img);

  if (!media.length) return null;

  const styles = {
    dark: {
      wrap: "mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2",
      card: "flex gap-2.5 items-start rounded-lg p-2.5 cursor-pointer border transition-colors bg-zinc-800/80 border-zinc-700 hover:border-zinc-500",
      title: "text-white text-xs font-semibold leading-tight line-clamp-1",
      desc:  "text-zinc-500 text-[10px] mt-0.5 line-clamp-2 leading-relaxed",
    },
    light: {
      wrap: "mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2",
      card: "flex gap-2.5 items-start rounded-lg p-2.5 cursor-pointer border transition-all bg-white border-stone-200 hover:border-stone-300 hover:shadow-sm",
      title: "text-stone-800 text-xs font-semibold leading-tight line-clamp-1",
      desc:  "text-stone-500 text-[10px] mt-0.5 line-clamp-2 leading-relaxed",
    },
    terminal: {
      wrap: "mt-3 space-y-1.5",
      card: "flex gap-2 items-start rounded p-2 cursor-pointer border transition-colors bg-black/30 border-green-900/50 hover:border-green-700/50",
      title: "text-green-400 text-xs font-bold line-clamp-1",
      desc:  "text-green-700 text-[10px] mt-0.5 line-clamp-2",
    },
  };

  const s = styles[cardStyle] || styles.dark;

  return (
    <>
      <div className={s.wrap}>
        {media.map((m, i) => {
          const src = resolveMediaImg(m.img);
          return (
            <div key={i} className={s.card} onClick={() => setSelected(m)}>
              {src && (
                <img
                  src={src}
                  alt={m.title || ""}
                  className="w-14 h-10 rounded object-cover shrink-0"
                />
              )}
              <div className="min-w-0 flex-1">
                {m.title && <p className={s.title}>{m.title}</p>}
                {m.description && <p className={s.desc}>{m.description}</p>}
                {m.link && (
                  <p className="text-indigo-400 text-[10px] mt-0.5 truncate">↗ {m.link.replace(/^https?:\/\//, "")}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {selected && (
        <MediaDetailModal media={selected} onClose={() => setSelected(null)} />
      )}
    </>
  );
};

export default ExperienceMediaCards;
